export const ROUND_DURATION_MS = 60_000;
export const SOLO_QUESTION_COUNT = 150;
export const DUEL_QUESTION_COUNT = 150;
export const CORRECT_POINTS = 2;
export const WRONG_POINTS = -1;

export type Operation = "add" | "sub" | "mul" | "div";
export type Difficulty = "easy" | "medium" | "hard";
export type CategoryId = "add" | "sub" | "mul" | "div" | "add_sub" | "mul_div" | "all";

export interface CategoryPreset {
  id: CategoryId;
  label: string;
  symbol: string;
  operations: Operation[];
}

export const CATEGORIES: CategoryPreset[] = [
  { id: "add", label: "Addition", symbol: "+", operations: ["add"] },
  { id: "sub", label: "Subtraction", symbol: "−", operations: ["sub"] },
  { id: "mul", label: "Multiplication", symbol: "×", operations: ["mul"] },
  { id: "div", label: "Division", symbol: "÷", operations: ["div"] },
  { id: "add_sub", label: "Add & Sub", symbol: "➕➖", operations: ["add", "sub"] },
  { id: "mul_div", label: "Mul & Div", symbol: "✖️➗", operations: ["mul", "div"] },
  { id: "all", label: "All Operations", symbol: "➕➖✖️➗", operations: ["add", "sub", "mul", "div"] },
];

export const DIFFICULTY_LABELS: Record<Difficulty, { emoji: string; label: string }> = {
  easy: { emoji: "😄", label: "EASY" },
  medium: { emoji: "😐", label: "MEDIUM" },
  hard: { emoji: "😱", label: "HARD" },
};

export const DIFFICULTY_RANGES: Record<Operation, Record<Difficulty, [number, number]>> = {
  add: { easy: [1, 9], medium: [1, 49], hard: [1, 99] },
  sub: { easy: [1, 9], medium: [1, 49], hard: [1, 99] },
  mul: { easy: [2, 5], medium: [2, 10], hard: [2, 19] },
  div: { easy: [2, 5], medium: [2, 10], hard: [2, 19] },
};

export interface SelectedCategory {
  categoryId: CategoryId;
  difficulty: Difficulty;
}

export interface Question {
  a: number;
  b: number;
  op: Operation;
  answer: number;
  options: number[];
}

export interface GameConfig {
  mode: "solo" | "duel";
  selectedCategory: SelectedCategory;
  player1Name: string;
  player2Name: string;
}

export interface RoundResult {
  name: string;
  score: number;
  correctCount: number;
  wrongCount: number;
  timeUsedMs: number;
}

export function winnerOf(p1: RoundResult, p2: RoundResult): string | null {
  if (p1.score === p2.score) return null;
  return p1.score > p2.score ? p1.name : p2.name;
}
